import React from 'react';

// import components
import LinkListCards from 'components/partials/link-list-cards';

// import types
import { LinkListCardProps } from 'types/link-list-card-props';
import { LinkObject } from 'types/link-object';

// import helpers
import { getLinkDataFromDato } from "helpers/get-link-data";

// Import Images
import { ReactComponent as IconLink } from "img/icons/icon-link.svg";

// import hooks
import { getLinkById } from 'hooks/use-generate-site-link';


const LinkListCardsCollectionBuilder: React.FC<{ linkListCardsCollectionData?: Queries.LinkListCardsCollectionBlockFragment, services?: Queries.ServiceFieldsFragment[] }> = ({ linkListCardsCollectionData, services }) => {

    
    const cards = linkListCardsCollectionData?.linkListCards?.map((card): LinkListCardProps | undefined => {

        if (!card) return undefined;

        const links: LinkObject[] = card.links?.map((link): LinkObject | undefined => {
            const linkData = getLinkDataFromDato(link?.link);
            if (!linkData) return undefined; // Check if linkData is null and filter it out

            return {
                url: linkData.url ?? '#',
                text: linkData.label ?? 'Error: Missing label',
                icon: IconLink,
            };
        }).filter((link): link is LinkObject => link !== undefined) as LinkObject[] || []; // Filter out null linkData

        return {
            headline: card.heading ?? 'Error: Missing headline',
            links: links,
        };

    }).filter((card): card is LinkListCardProps => card !== undefined) || [];

    const serviceCard = getServicesLinkCard(services ?? []);

    if (serviceCard) {
        cards.push(serviceCard);
    }

    // check if there are no cards
    if (cards.length === 0) {
        return null;
    }

    return (
        <LinkListCards
            headline={linkListCardsCollectionData?.heading ?? ''}
            cards={cards}
        />
    );
};

export default LinkListCardsCollectionBuilder;

const getServicesLinkCard = (services: Queries.ServiceFieldsFragment[]): LinkListCardProps | null => {

    const serviceLinks = getServicesLinks(services);

    // if no serviceLinks return null
    if (serviceLinks.length === 0) {
        return null;
    }

    return {
        headline: 'Related Services',
        links: serviceLinks,
    };
}

const getServicesLinks = (services: Queries.ServiceFieldsFragment[]): LinkObject[] => {
    return services.map((service): LinkObject => {
        let serviceUrl = getLinkById(service.id) || '';
        return {
            url: serviceUrl,
            text: service.title ?? 'Unknown Service',
            icon: IconLink,
        };
    });
}